module.exports = {
  siteTitle: 'Hausegger Inc.', // <title>
  manifestName: 'HLT',
  manifestShortName: 'Landing', // max 12 characters
  manifestStartUrl: '/',
  manifestBackgroundColor: '#663399',
  manifestThemeColor: '#663399',
  manifestDisplay: 'standalone',
  manifestIcon: 'src/assets/img/website-icon.png',
  pathPrefix: '/', // This path is subpath of your hosting https://domain/portfolio
  heading: 'Hausegger Inc.',
  subHeading: 'Innovative Healthcare Software Development',
  // social
  socialLinks: [
    {
      style: 'brands',
      icon: 'fa-twitter',
      name: 'Twitter',
      url: 'https://twitter.com/hhausegger',
    },
    {
      style: 'solid',
      icon: 'fa-envelope',
      name: 'Email',
      url: 'mailto:hello@hausegger-inc.com',
    },
  ],
};
